// 设备类型
export const DeviceTypes = {
  DEVICE_TYPE_SERVER: 1,
  DEVICE_TYPE_NETWORK: 2,
  DEVICE_TYPE_STORAGE: 3,
  DEVICE_TYPE_OTHER: 4
};

// 加电状态
export const CabinetOpenStatus = {
         Enabled: 3, //已开通
  Disabled: 1,//未开通
  Enabling: 2,//开通中
  Disabling: 4//关闭中
       };



// WEBPACK FOOTER //
// ./src/components/cabinetVisual/CabinetConstants.js